import { TICKERS, GET_CURRENT_PRICE } from 'client/api';
import { client, clientUser } from 'client/request';
import queryString from 'query-string';

const getTickers = async () => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientUser.get(TICKERS, {});

    return res.data;
  } catch (err) {
    throw err;
  }
};

const getCurrentPrice = async (ticker) => {
  const url = ticker
    ? `${GET_CURRENT_PRICE}?${queryString.stringify({ ticker })}`
    : GET_CURRENT_PRICE;

  // eslint-disable-next-line no-useless-catch
  try {
    const res = await client.get(url, {});

    return res.data;
  } catch (err) {
    throw err;
  }
};

export default {
  getTickers,
  getCurrentPrice
};
